<template>
  <Forms ref="frmPermission"
           :title="title"
           :showHelp="true"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="$emit('Clear')"
           v-on:Search="$emit('Search')"
          >
            <div class="container-cabecalho-filtro" style="  margin-bottom: 0.5rem;">
              <div><i class="fas fa-hard-hat text-third pr-3" style="font-size: 50px;float: left;"></i></div>
              <div class="title_painel">Painel de Supervisão</div>
            </div>
            <div class="d-flex">
                <div class="form-group">
                  <label class="label_filtro" for="CodigoObra">Código</label>
                  <input v-model="datafilter.codigoObra" type="text" class="form-control" placeholder="Digite o Codigo da Obra">
                </div>
            </div>
            <div class="d-flex">
                <div class="form-group">
                  <label class="label_filtro" for="Cliente">Cliente</label>
                  <input v-model="datafilter.cliente" type="text" class="form-control" placeholder="Digite o nome do Cliente ">
                </div>
            </div>
            <div class="d-flex">
              <div class="form-group">
                <label class="label_filtro" for="statusVistoria">Status Vistoria</label>
                <select name="statusVistoria" v-model="form.statusVistoria.value" class="form-control" id="exampleFormControlSelect2">
                  <option :value="null">Todos os Status</option>
                  <option v-for="obj in OptionStatusSurvey" v-bind:key="obj.value" :value="obj.id">{{obj.value}}</option>
                </select>
              </div>
            </div>
            <div class="d-flex">
              <div class="form-group">
                <label class="label_filtro" for="txtInsured">Data Da Vistoria</label>
                <datepicker name="txtDateStart" v-model="form.dataInicioSolicitacao.value"
                      :format="'dd/MM/yyyy'"
                      :language="ptBR"
                      :placeholder="$lang.Common.DatePlaceholder"
                      :clear-button="true"
                      :clear-button-icon="'fas fa-times'"
                      :calendar-button="true"
                      :calendar-button-icon="'fa fa-calendar'"
                      :bootstrap-styling="true"
                      :full-month-name="true"
                      :use-utc="true"/>
              </div>
            </div>
            <div class="d-flex">
              <div class="form-group">
                <label class="label_filtro" for="txtInsured">Responsável</label>
                <autocomplete-z ref="responsavelTypeahead"
                    placeholder="Digite o nome do Responsável"
                    iconClass="fas fa-users"
                    :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                    :debounceLength="3"
                    :formField="form.responsavelID"
                    v-on:search="onSearchResponsavelAll"
                    v-on:changeCode="onChangeCodeResponsavel"
                    :ShowCode="false" />
              </div>
            </div>
            <div class="d-flex">
              <div class="form-group">
                <label class="label_filtro" for="txtInsured">Tipo Obra</label>
                <autocomplete-z ref="TipoObraTypeahead"
                      placeholder="Digite o Tipo da Obra"
                      iconClass="fas fa-hammer"
                      :serializer="(tipoobra) => tipoobra.nome"
                      :debounceLength="3"
                      :formField="form.TipoObraID"
                      v-on:search="onSearchTipoObra"
                      v-on:changeCode="onChangeCodeTipoObra"
                      :ShowCode="false"
                />
              </div>
            </div>
            <div class="d-flex">
                <div class="form-group">
                <label class="label_filtro" for="funcao">Função</label>
                <input v-model="datafilter.funcao" type="text" class="form-control" placeholder="Digite o nome da Função">
              </div>
            </div>
            <div class="d-flex">
              <div class="form-group">
                <label class="label_filtro" for="contrato">Contrato</label>
                <input v-model="datafilter.numeroContrato" class="form-control" placeholder="Digite o numero do Contrato">
              </div>
            </div>
            </Forms>
</template>
<script>
import searchSurvey from './searchSurvey.js'
export default searchSurvey
</script>
<style scoped>
.container-cabecalho-filtro{
  width: 100%;
  height: fit-content;
  display: flex;
  margin-left: 0.2rem;
}
.form-group {
  width: 100%;
  margin: 0.2rem;
}
.label_filtro {
  margin-bottom: 0.2rem;
}
.title_painel {
  font-size: 16px;
  font-family: Segoe UI;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/views/private/Survey/components/searchSurvey/searchSurvey.vue